import React from 'react';
import '../../../styles/components/LogoSVG.css';

// Import des logos (WebP pour poids optimisé)
import logoVertTexte from '../../../styles/images/logoverttexte.webp';
import logoBeige from '../../../styles/images/logo_beige.png';

// Import des singes (WebP pour poids optimisé)
import singeOrange from '../../../styles/images/singequimarcheorange.webp';
import singeVert from '../../../styles/images/singequimarchevert.webp';
import singeSuspenduOrange from '../../../styles/images/singesuspenduorange.webp';
import singeSuspenduVert from '../../../styles/images/singesuspenduvert.webp';
import singeTicketVert from '../../../styles/images/singeticketvert.webp';

// Définition des variantes disponibles
export type LogoVariant =
  | 'beige'
  | 'vertTexte'
  | 'what2Do'
  | 'singeOrange'
  | 'singeVert'
  | 'singeSuspenduOrange'
  | 'singeSuspenduVert'
  | 'singeTicketVert';

interface LogoSVGProps {
  className?: string;
  variant: LogoVariant;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'auto';
  padding?: number;
  color?: string;
}

const logoMap: Record<LogoVariant, string> = {
  beige: logoBeige,
  vertTexte: logoVertTexte,
  what2Do: logoVertTexte,
  singeOrange: singeOrange,
  singeVert: singeVert,
  singeSuspenduOrange: singeSuspenduOrange,
  singeSuspenduVert: singeSuspenduVert,
  singeTicketVert: singeTicketVert
};

const LogoSVG: React.FC<LogoSVGProps> = ({ 
  className,
  variant = 'beige',
  size = 'md',
  padding = 8,
  color
}) => {
  const sizeMap = {
    sm: 24,
    md: 32,
    lg: 40,
    xl: 48,
    xxl: 64,
    auto: undefined
  };

  const style = size === 'auto' 
    ? { padding: `${padding}px` } as React.CSSProperties
    : { 
        '--logo-size': `${sizeMap[size]}px`,
        width: sizeMap[size],
        height: sizeMap[size]
      } as React.CSSProperties;

  return (
    <div className={`logo-svg ${size === 'auto' ? 'logo-svg--auto' : ''} ${className || ''}`} style={style}>
      <img
        src={logoMap[variant]}
        alt=""
        className="logo-svg__image"
        style={color ? { filter: `color(${color})` } : undefined}
        onError={(e) => { (e.target as HTMLImageElement).style.visibility = 'hidden'; }}
      />
    </div>
  );
};

export default React.memo(LogoSVG); 